import Plugin from './autocomplete.js';
export { default as Autocomplete } from './autocomplete.js';
import Plugin$1 from './breadcrumb.js';
export { default as Breadcrumb } from './breadcrumb.js';
import Plugin$2 from './button.js';
export { default as Button } from './button.js';
import Plugin$3 from './carousel.js';
export { default as Carousel } from './carousel.js';
import Plugin$4 from './checkbox.js';
export { default as Checkbox } from './checkbox.js';
import Plugin$6 from './collapse.js';
export { default as Collapse } from './collapse.js';
import Plugin$5 from './clockpicker.js';
export { default as Clockpicker } from './clockpicker.js';
import { P as Plugin$7 } from './index-e19fd414.js';
export { C as Color, P as Colorpicker } from './index-e19fd414.js';
import Plugin$8 from './datepicker.js';
export { default as Datepicker } from './datepicker.js';
import Plugin$9 from './datetimepicker.js';
export { default as Datetimepicker } from './datetimepicker.js';
import Plugin$a from './dialog.js';
export { default as Dialog, DialogProgrammatic } from './dialog.js';
import Plugin$b from './dropdown.js';
export { default as Dropdown } from './dropdown.js';
import Plugin$c from './field.js';
export { default as Field } from './field.js';
import Plugin$d from './icon.js';
export { default as Icon } from './icon.js';
import Plugin$e from './image.js';
export { default as Image } from './image.js';
import Plugin$f from './input.js';
export { default as Input } from './input.js';
import Plugin$g from './loading.js';
export { default as Loading, LoadingProgrammatic } from './loading.js';
import Plugin$h from './menu.js';
export { default as Menu } from './menu.js';
import Plugin$i from './message.js';
export { default as Message } from './message.js';
import Plugin$j from './modal.js';
export { default as Modal, ModalProgrammatic } from './modal.js';
import Plugin$l from './notification.js';
export { default as Notification, NotificationProgrammatic } from './notification.js';
import Plugin$k from './navbar.js';
export { default as Navbar } from './navbar.js';
import Plugin$m from './numberinput.js';
export { default as Numberinput } from './numberinput.js';
import Plugin$n from './pagination.js';
export { default as Pagination } from './pagination.js';
import Plugin$o from './progress.js';
export { default as Progress } from './progress.js';
import Plugin$p from './radio.js';
export { default as Radio } from './radio.js';
import Plugin$q from './rate.js';
export { default as Rate } from './rate.js';
import Plugin$r from './select.js';
export { default as Select } from './select.js';
import Plugin$s from './skeleton.js';
export { default as Skeleton } from './skeleton.js';
import Plugin$t from './sidebar.js';
export { default as Sidebar } from './sidebar.js';
import Plugin$u from './slider.js';
export { default as Slider } from './slider.js';
import Plugin$v from './snackbar.js';
export { default as Snackbar, SnackbarProgrammatic } from './snackbar.js';
import Plugin$w from './steps.js';
export { default as Steps } from './steps.js';
import Plugin$x from './switch.js';
export { default as Switch } from './switch.js';
import Plugin$y from './table.js';
export { default as Table } from './table.js';
import Plugin$z from './tabs.js';
export { default as Tabs } from './tabs.js';
import Plugin$A from './tag.js';
export { default as Tag } from './tag.js';
import Plugin$B from './taginput.js';
export { default as Taginput } from './taginput.js';
import Plugin$C from './timepicker.js';
export { default as Timepicker } from './timepicker.js';
import Plugin$D from './toast.js';
export { default as Toast, ToastProgrammatic } from './toast.js';
import Plugin$E from './tooltip.js';
export { default as Tooltip } from './tooltip.js';
import Plugin$F from './upload.js';
export { default as Upload } from './upload.js';
import { m as merge } from './helpers-8130329a.js';
export { b as bound, A as copyAppContext, d as createAbsoluteElement, l as createNewEvent, f as escapeRegExpChars, z as getComponentFromVNode, n as getMonthNames, g as getValueByPath, o as getWeekdayNames, h as hasFlag, i as indexOf, u as isCustomElement, v as isDefined, x as isFragment, c as isMobile, w as isNil, y as isTag, e as isVueComponent, q as isWebpSupported, p as matchWithGroups, m as merge, a as mod, k as multiColumnSort, j as removeDiacriticsFromString, r as removeElement, s as sign, t as toCssWidth } from './helpers-8130329a.js';
import { s as setOptions, c as config } from './config-86592f14.js';
import { u as use, r as registerComponentProgrammatic } from './plugins-9a909142.js';
import ConfigComponent from './config.js';
export { default as ConfigProgrammatic } from './config.js';
import './Autocomplete-a974694b.js';
import './FormElementMixin-6da0c31e.js';
import './Input-cb6c4f29.js';
import './Icon-52393747.js';
import 'vue';
import './Button-e54fe793.js';
import './ProviderParentMixin-edbbe118.js';
import './InjectedChildMixin-79185917.js';
import './Image-abc397f0.js';
import './Checkbox-f4e879fb.js';
import './CheckRadioMixin-43df7c28.js';
import './TimepickerMixin-106f0ec1.js';
import './DropdownItem-966537c6.js';
import './trapFocus-3002f535.js';
import './Field-6fe00be6.js';
import './typeof-92b42de1.js';
import './classCallCheck-119e2995.js';
import './Select-e02cd04d.js';
import './Tooltip-4a5349db.js';
import './Datepicker-bb248276.js';
import './Timepicker-8f0cc690.js';
import './Modal-df95de0a.js';
import './Loading-a8c58d9b.js';
import './ssr-b847d137.js';
import './MessageMixin-d4a6571e.js';
import './Progress-5d4b7b8c.js';
import './NoticeMixin-d4159c0a.js';
import './Pagination-e5154b95.js';
import './TabbedChildMixin-448f68be.js';
import './SlotComponent-a420a8b4.js';
import './Tag-80125824.js';

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Autocomplete: Plugin,
    Breadcrumb: Plugin$1,
    Button: Plugin$2,
    Carousel: Plugin$3,
    Checkbox: Plugin$4,
    Clockpicker: Plugin$5,
    Collapse: Plugin$6,
    Colorpicker: Plugin$7,
    Datepicker: Plugin$8,
    Datetimepicker: Plugin$9,
    Dialog: Plugin$a,
    Dropdown: Plugin$b,
    Field: Plugin$c,
    Icon: Plugin$d,
    Image: Plugin$e,
    Input: Plugin$f,
    Loading: Plugin$g,
    Menu: Plugin$h,
    Message: Plugin$i,
    Modal: Plugin$j,
    Navbar: Plugin$k,
    Notification: Plugin$l,
    Numberinput: Plugin$m,
    Pagination: Plugin$n,
    Progress: Plugin$o,
    Radio: Plugin$p,
    Rate: Plugin$q,
    Select: Plugin$r,
    Skeleton: Plugin$s,
    Sidebar: Plugin$t,
    Slider: Plugin$u,
    Snackbar: Plugin$v,
    Steps: Plugin$w,
    Switch: Plugin$x,
    Table: Plugin$y,
    Tabs: Plugin$z,
    Tag: Plugin$A,
    Taginput: Plugin$B,
    Timepicker: Plugin$C,
    Toast: Plugin$D,
    Tooltip: Plugin$E,
    Upload: Plugin$F
});

var Buefy = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // Options
    setOptions(merge(config, options, true));
    // Components
    for (var componentKey in components) {
      Vue.use(components[componentKey]);
    }
    // Config component
    registerComponentProgrammatic(Vue, 'config', ConfigComponent);
    Vue.config.globalProperties.$buefy.globalNoticeInterval = null;
  }
};
use(Buefy);

export { Buefy as default };
